import React, { useMemo, useRef } from "react";
// import Header from './../../components/Header';
import { useState } from "react";
import { getAllBanks, getCities } from "./../../stores/services/bank.service";
import { getBranchByBankName } from "./../../stores/services/branch.service";
import { editUnitHolder } from "./../../stores/services/unit-holder.service";
import { getFundByAmc } from "./../../stores/services/funds.service";
import { useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
} from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import ToggleButton from "react-toggle-button";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import InputMask from "react-input-mask";
import {
  accountTitle_AccountNumber_Regex,
  numberWithCommas,
  systematicVPSType,
  typeRatioSystematic,
  unitholderCategoryType,
} from "./../../utils/customFunction";
import { getSalesCompanyByAMCCode } from "../../stores/services/sales.service";
import { getInvestorByID } from "../../stores/services/potential-investor.service";
import moment from "moment";
import { useSelector } from "react-redux";
import Select from "react-select";
import { FiUploadCloud } from "react-icons/fi";
import { IoClose } from "react-icons/io5";
import NumberFormat from "react-number-format";

const EditClients = () => {
  const renderTypeDropdown = [
    { label: "Individual", value: "Individual" },
    { label: "Corporate", value: "Corporate" },
  ];

  const portfolioArr = [
    { label: "Fund", value: "fund" },
    { label: "SMA", value: "sma" },
  ];
  const taxStatusArr = [
    { label: "Filer", value: "Filer" },
    { label: "Non-Filer", value: "Non-Filer" },
    { label: "Exempted", value: "Exempted" },
  ];

  const territoryArr = [
    { label: "Islamabad", value: "Islamabad" },
    { label: "Punjab", value: "Punjab" },
    { label: "Khyber Pakhtunkhwa", value: "Khyber Pakhtunkhwa" },
    { label: "Balochistan", value: "Balochistan" },
    { label: "Sindh", value: "Sindh" },
    { label: "Gilgit Baltistan", value: "Gilgit Baltistan" },
    { label: "Azad Kashmir", value: "Azad Kashmir" },
  ];

  const incomeTaxStatusArr = [
    { label: "Filer", value: "Filer" },
    { label: "Non-Filer", value: "Non-Filer" },
  ];

  const riskFactorOpt = [
    {
      label: "Low",
      value: "Low",
    },
    {
      label: "Medium",
      value: "Medium",
    },
    {
      label: "High",
      value: "High",
    },
  ];

  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  const history = useHistory();
  const [employeeId, setEmployeeId] = useState("");
  const [joiningDate, setJoiningDate] = useState("");
  const [leavingDate, setLeavingDate] = useState("");
  const [employeeNominee, setEmployeeNominee] = useState<any>([
    {
      nominee_name: "",
      nominee_relation: "",
      nominee_cnic: "",
    },
  ]);
  //hooks for getting all inputs from user
  const [autoInvest, setAutoInvest] = useState("false");
  const [fund, setFund] = useState("");
  const [amcName, setAmcName] = useState("");
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const fund_code = JSON.parse(sessionStorage.getItem("fund_code") || "[]");
  const [name, setName] = useState("");
  const [folioNo, setFolioNo] = useState("");
  const [cnic, setCnic] = useState("");
  const [cnicExpiry, setCnicExpiry] = useState("");
  const [ntn, setNtn] = useState("");
  const [mainFolioNo, setMainFolioNo] = useState("");
  const [taxStatus, setTaxStatus] = useState("");
  const [image, setImage] = useState<any>("");
  const [profilePicture, setProfilePicture] = useState<any>();
  const [calculateAge, setCalculateAge] = useState<any>();
  const [onhover, setOnhover] = useState<boolean>(false);
  const inputRefUser = useRef<HTMLInputElement>(null);
  const [riskFactor, setRiskFactor] = useState("");
  const [DOB, setDOB] = useState("");
  const [showImage, setShowImage] = useState<boolean>(false);
  const [unitholderType, setUnitholderType] = useState("");
  const [typeVPS, setTypeVPS] = useState("");
  //
  const [clientEmail, setClientEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  // const [filer, setFiler] = useState(false)	;
  // const updateFiler = () => setFiler(!filer)
  const [province, setProvince] = useState("");
  //
  const [rangeTimer, setRangeTimer] = useState<any>(null);
  const [accTitle, setAccTitle] = useState("");
  const [accNo, setAccNo] = useState("");
  const [bankname, setBankName] = useState("");
  const [branchName, setBranchName] = useState("");
  //
  const [blnUpdate, setBlnUpdate] = useState<any>();
  const [reinvestCheck, setReinvestCheck] = useState(false);
  const [lifetimeCNIC, setLifetimeCNIC] = useState(false);
  const email = sessionStorage.getItem("email") || "";
  const amcCode = sessionStorage.getItem("amc_code") || "";
  const [fundLoading, setFundLoading] = useState<boolean>(false);
  const [disableAddBtn, setDisableAddBtn] = useState<boolean>(false);
  const [father, setFather] = useState("");
  const [tax_exempt, setTax_exempt] = useState(false);
  const [zakat_exempt, setZakat_exempt] = useState(false);
  const [type, setType] = useState("");
  // guardian
  const [guardian_name, setGuardian_name] = useState("");
  const [guardian_relation, setGuardian_relation] = useState("");
  const [guardian_cnic, setGuardian_cnic] = useState("");
  // nominee
  const [nominee_name, setNomineeName] = useState("");
  const [nominee_relation, setNomineeRelation] = useState("");
  const [nominee_cnic, setNomineeCnic] = useState("");
  // joint_holder One
  const [joint_h_1_name, setJointHolderOneName] = useState("");
  const [joint_h_1_father_spouse, setJointHolderOneFather] = useState("");
  const [joint_h_1_cnic, setJointHolderOneCnic] = useState("");
  const [joint_h_1_taxStatus, setJointHolderOneTaxStatus] = useState("");
  // joint_holder two
  const [joint_h_2_name, setJointHolderTwoName] = useState("");
  const [joint_h_2_father_spouse, setJointHolderTwoFather] = useState("");
  const [joint_h_2_cnic, setJointHolderTwoCnic] = useState("");
  const [joint_h_2_taxStatus, setJointHolderTwoTaxStatus] = useState("");
  // joint_holder Three
  const [joint_h_3_name, setJointHolderThreeName] = useState("");
  const [joint_h_3_father_spouse, setJointHolderThreeFather] = useState("");
  const [joint_h_3_cnic, setJointHolderThreeCnic] = useState("");
  const [joint_h_3_taxStatus, setJointHolderThreeTaxStatus] = useState("");

  const [portfolioManagement, setPortfolioManagement] = useState("");

  const [cdc_IAS, setCDCIAS] = useState("");
  const [cdc_subAccount, setCDCSubAccount] = useState("");
  const [cdc_participantID, setCDCParticipantID] = useState("");

  const [allSalesCompany, setAllSalesCompany] = useState<any>([]);
  const [errors, setErrors] = useState<{ [key: number]: string | null }>({});
  const [errorThreshold, setErrorThreshold] = useState(false);
  const [totalInvestment, setTotalInvestment] = useState<any>("");
  const [subFundsBlocks, setSubFundsBlocks] = useState<any>([]);
  const [amount, setAmount] = useState<any>();

  const getAllSalesCompany = async (code: string) => {
    try {
      const response = await getSalesCompanyByAMCCode(email, code);
      if (response.data.status == 200) {
        setAllSalesCompany(response.data.data);
      } else {
        setAllSalesCompany([]);
      }
    } catch (error) {
      setAllSalesCompany([]);
    }
  };

  React.useEffect(() => {
    const obj = JSON.parse(sessionStorage.getItem("clientObj") || "");
    if (obj.balance_unit) {
      setTotalFunds(JSON.parse(obj.balance_unit));
    }
    setAccTitle(obj.account_title);
    setAccNo(obj.account_no);
    setType(obj.type);
    setFather(obj.father_spouse);
    if (obj.tax_exempt === "true") {
      setTax_exempt(true);
    } else {
      setTax_exempt(false);
    }
    if (obj.zakat_exempt === "true") {
      setZakat_exempt(true);
    } else {
      setZakat_exempt(false);
    }
    if (obj?.profile_picture) {
      setShowImage(true);
    }
    setDOB(obj?.dob || "");
    setCalculateAge(obj?.age || "");
    setImage(obj?.profile_picture || "");
    setRiskFactor(obj?.risk_factor || "");
    setPhone(obj.phone);
    setCnicExpiry(obj.cnic_expiry);
    setClientEmail(obj.email);
    setMainFolioNo(obj.main_folio_no);
    setBankName(obj.bank_name);
    getBranchByName(obj.bank_name);
    setBranchName(obj.branch_name);
    setAmcName(obj.amc_code);
    setBlnUpdate(obj.balance_unit);
    setFolioNo(obj.folio_no.replace("UNITHOLDER_", ""));
    if (obj?.unitholder_Type === "Employee") {
      setEmployeeId(obj?.folio_no);
    }
    setCnic(obj.cnic);
    setName(obj.name);
    setNtn(obj.ntn);
    // setClientEmail(obj.client_email);
    setMobile(obj.mobile);
    setGuardian_name(obj.guardian_name);
    setGuardian_relation(obj.guardian_relation);
    setGuardian_cnic(obj.guardian_cnic);
    setNomineeName(obj.nominee_name);
    setNomineeRelation(obj.nominee_relation);
    setNomineeCnic(obj.nominee_cnic);
    setJointHolderOneName(obj.joint_h_1_name);
    setJointHolderOneFather(obj.joint_h_1_father_spouse);
    setJointHolderOneCnic(obj.joint_h_1_cnic);
    setJointHolderTwoName(obj.joint_h_2_name);
    setJointHolderTwoFather(obj.joint_h_2_father_spouse);
    setJointHolderTwoCnic(obj.joint_h_2_cnic);
    setJointHolderThreeName(obj.joint_h_3_name);
    setJointHolderThreeFather(obj.joint_h_3_father_spouse);
    setJointHolderThreeCnic(obj.joint_h_3_cnic);
    setPortfolioManagement(obj.portfolio_management);
    // obj.reinvest === "true" ? setReinvestCheck(true) : setReinvestCheck(false);
    setReinvestCheck(obj.reinvest);
    setLifetimeCNIC(obj?.lifetime_cnic === true ? true : false);
    setAddress(obj.address);
    setCity(obj.city);
    // setFiler(obj.filer);
    // obj.filer === 'true' ? setFiler(true) : setFiler(false);
    setProvince(obj.province);
    setTaxStatus(obj.tax_status);
    setJointHolderOneTaxStatus(obj.joint_h1_tax_status);
    setJointHolderTwoTaxStatus(obj.joint_h2_tax_status);
    setJointHolderThreeTaxStatus(obj.joint_h3_tax_status);
    setCDCIAS(obj.cdc_ias !== "undefined" ? obj.cdc_ias : "");
    setCDCSubAccount(
      obj.cdc_sub_account !== "undefined" ? obj.cdc_sub_account : "",
    );
    setCDCParticipantID(
      obj.cdc_participant_id !== "undefined" ? obj.cdc_participant_id : "",
    );
    if (obj.unitholder_Type) setUnitholderType(obj.unitholder_Type);
    else setUnitholderType("Unitholder");
    if (obj?.unitholder_Type === "Participant" && obj.systematic_investment) {
      let temp =
        typeof obj.systematic_investment === "string"
          ? JSON.parse(obj.systematic_investment)
          : obj.systematic_investment;
      setSubFundsBlocks(temp?.investment_blocks);
      setAmount(temp?.investment_amount || 0);
      setTypeVPS(temp?.allocation_scheme);
    }
    setSalesInHouse(
      obj.in_house_sale == "true" || obj.in_house_sale == true
        ? "true"
        : "false",
    );
    setSalesCompany(obj.sales_company || "");
    setSalesPerson(obj.sales_person || "");
    setJoiningDate(obj.joining_date || "");
    setLeavingDate(obj.leaving_date || "");
    if (obj?.unitholder_Type === "Employee" && obj.employee_nominee) {
      let temp = JSON.parse(obj.employee_nominee);
      setEmployeeNominee(temp);
    }
  }, []);
  const getfundByAmcCode = async () => {
    allFunds.length = 0;
    setAllFunds(allFunds);
    //get funds by amc for dropdown
    try {
      const response = await getFundByAmc(
        email,
        amcCode,
        fund_code?.length > 0 ? fund_code : "",
      );
      setAllFunds(response.data.data);
      if (response?.data?.data?.length > 0) {
        setFundLoading(false);
      } else {
        setFundLoading(true);
      }
    } catch (error) {}
  };
  //error getting hooks
  const [accTitleError, setAccTitleError] = useState("");
  const [accNoError, setAccNoError] = useState("");
  const [bankNameError, setBankNameError] = useState("");
  const [branchNameError, setBranchNameError] = useState("");
  const [amcNameError, setAmcError] = useState("");
  const [blnUpdateError, setBlnUpdateError] = useState("");
  const [folioNoError, setFolioNoError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [clientEmailError, setClientEmailError] = useState("");
  const [cnicExpiryError, setCnicExpiryError] = useState("");
  const [cnicError, setCnicError] = useState("");
  const [ntnError, setNtnError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [addressError, setAddressError] = useState("");
  const [cityError, setCityError] = useState("");
  const [provinceError, setProvinceError] = useState("");
  const [nameError, setNameError] = useState("");
  const [Loading, setLoading] = useState(false);
  //for dropdown data
  const [amcdata, setAmcdata] = useState<any>([]);
  const [bankNameData, setBankNameData] = useState<any>([]);
  const [allbranchesData, setAllBranchesData] = useState<any>([]);
  const [allFunds, setAllFunds] = useState<any>([]);
  const [allTxData, setAllTxData] = useState<any>([]);
  const [branchLoading, setBranchLoading] = useState<boolean>(false);
  const [allCitiesData, setAllCitiesData] = useState<any>([]);
  const [totalFunds, setTotalFunds] = useState<any>([]);
  const [branchCheckFlag, setBranchCheckFlag] = useState(false);
  const [salesCompany, setSalesCompany] = useState("");
  const [salesPerson, setSalesPerson] = useState("");
  const [salesInHouse, setSalesInHouse] = useState("");
  const getBranchByName = async (name: string) => {
    setBranchLoading(true);
    allbranchesData.length = 0;
    setAllBranchesData(allbranchesData);
    //get all branches for selected bank for dropdown
    try {
      const response = await getBranchByBankName(email, name, amcCode);
      setAllBranchesData(response.data.data);
      if (response?.data?.data?.length > 0) {
        setBranchCheckFlag(false);
      } else {
        setBranchCheckFlag(true);
      }
    } catch (error) {}
    setBranchLoading(false);
  };
  React.useEffect(() => {
    const fetchAmc = async () => {
      bankNameData.length = 0;
      setBankNameData(bankNameData);
      //get all banks list for dropdown
      try {
        const response = await getAllBanks(email, "", "", amc_code);
        setBankNameData(response.data.data);
      } catch (error) {}
      //get tx nature data for dropdown
      try {
        const response = await getCities();
        setAllCitiesData(response.data.cities);
      } catch (error) {}
    };
    getfundByAmcCode();
    fetchAmc();
    getAllSalesCompany(amcCode);
  }, []);

  const borderRadiusStyle = { borderRadius: 2 };

  const renderBankNameDropdown = () => {
    const options =
      bankNameData?.map((item: any) => {
        return {
          value: item.bank_code.replace("BANK_", ""),
          label: `${item.bank_code.replace("BANK_", "")}-${item.bank_name}`,
        };
      }) || [];
    options.push({ label: "Other", value: "Other" });
    return options;
  };

  //render dropdown for branch name data
  const renderBranchsDropdown = () => {
    return allbranchesData.map((item: any, index: string) => {
      return (
        <option key={index} value={item.branch_code}>
          {item.branch_code}-{item.branch_name}
        </option>
      );
    });
  };

  const renderFundsDropdown = () => {
    return allFunds.map((item: any, index: string) => {
      return {
        value: item.fund_name,
        label: item.fund_name,
      };
    });
  };

  const renderSystematicVPSType = () => {
    return systematicVPSType?.map((item: any) => {
      return {
        value: item,
        label: item,
      };
    });
  };

  const folioRegex = new RegExp("^[A-Z]{1,3}-[A-Z]{1,3}-[0-9]{1,8}$");

  const renderCitiesDropdown = () => {
    return allCitiesData.map((item: any) => {
      return {
        value: item,
        label: item,
      };
    });
  };

  const renderVPSFundsDropdown = () => {
    return allFunds
      ?.filter(
        (ele) =>
          ele?.nature === "Voluntary Pension Fund" &&
          ele?.fund_type === "main_fund",
      )
      ?.map((item: any, index: string) => {
        return {
          value: item?.symbol_code,
          label: `${item?.fund_name} (${item?.symbol_code})`,
        };
      });
  };

  const renderSalesCompany = () => {
    return allSalesCompany?.map((item: any) => {
      return {
        value: item?.company_code,
        label: item?.company_name,
      };
    });
  };

  const renderSalesPerson = () => {
    return allSalesCompany
      .find((item) => item?.company_code == salesCompany)
      ?.persons?.map((item: any) => {
        return {
          value: item?.id,
          label: `${item.name}(${item.email})`,
        };
      });
  };

  const renderUniholderType = () => {
    return unitholderCategoryType?.map((item: any) => {
      return {
        value: item,
        label: item,
      };
    });
  };

  //processing
  const validate = () => {
    let accTitleErr,
      nameErr,
      accNoErr,
      banknameErr,
      branchNameErr,
      amcErr,
      cnicExpErr,
      phoneErr = "";
    let folioErr,
      cnicErr,
      ntnErr,
      mobileErr,
      addressErr,
      cityErr = "",
      provinceErr = "";
    accTitle.trim() === "" ? (accTitleErr = "Required") : (accTitleErr = "");
    accNo.trim() === "" ? (accNoErr = "Required") : (accNoErr = "");
    bankname.trim() === "" ? (banknameErr = "Required") : (banknameErr = "");
    branchName.trim() === ""
      ? (branchNameErr = "Required")
      : (branchNameErr = "");
    amcName.trim() === "" ? (amcErr = "Required") : (amcErr = "");
    folioNo.trim() === "" ? (folioErr = "Required") : (folioErr = "");

    if (
      accTitleErr ||
      cnicExpErr ||
      phoneErr ||
      accNoErr ||
      nameErr ||
      branchNameErr ||
      amcErr ||
      folioErr ||
      cnicErr ||
      ntnErr ||
      mobileErr ||
      addressErr ||
      cityErr ||
      provinceErr
    ) {
      setAccTitleError(accTitleErr);
      setPhoneError(phoneErr);
      setCnicError(cnicExpErr);
      setAccNoError(accNoErr);
      setBankNameError(banknameErr);
      setBranchNameError(branchNameErr);
      setAmcError(amcErr);
      setFolioNoError(folioErr);
      setCnicError(cnicErr);
      setNtnError(ntnErr);
      setMobileError(mobileErr);
      setAddressError(addressErr);
      setCityError(cityErr);
      setProvinceError(provinceErr);
      return false;
    } else {
      return true;
    }
  };
  const addClients = async () => {
    const isValid = validate();
    if (isValid) {
      if (unitholderType && unitholderType === "Employee" && !employeeId) {
        toast.error("Employee No should not be empty");
        return;
      }

      if (!unitholderType) {
        toast.error("Unitholder Type should not be empty");
        return;
      }

      if (Object.keys(errors).length === 0) {
      }
      if (Object.values(errors).every((value) => value === null)) {
      } else {
        toast.error("Kindly Resolve Error in Systematic investment");
        return;
      }
      if (
        unitholderType === "Participant" &&
        subFundsBlocks[0]?.parentProportion < 100
      ) {
        toast.error("Total Investment should not be less than 100%");
        return;
      }
      const systematicInvestment: any = unitholderType === "Participant" && {
        total_block_invest: subFundsBlocks[0].parentProportion,
        allocation_scheme: typeVPS,
        investment_amount: amount,
        investment_blocks: subFundsBlocks,
      };
      setLoading(true);
      try {
        const response = await editUnitHolder(
          email,
          unitholderType && unitholderType === "Employee"
            ? employeeId
            : folioNo,
          accNo,
          bankname,
          blnUpdate,
          cnic,
          mobile,
          city,
          accTitle,
          branchName,
          amcName,
          ntn,
          address,
          name,
          mainFolioNo,
          phone,
          cnicExpiry,
          JSON.stringify(reinvestCheck),
          clientEmail,
          father,
          tax_exempt.toString(),
          zakat_exempt.toString(),
          type,
          guardian_name,
          guardian_relation,
          guardian_cnic,
          nominee_name,
          nominee_relation,
          nominee_cnic,
          joint_h_1_name,
          joint_h_1_father_spouse,
          joint_h_1_cnic,
          joint_h_2_name,
          joint_h_2_father_spouse,
          joint_h_2_cnic,
          joint_h_3_name,
          joint_h_3_father_spouse,
          joint_h_3_cnic,
          portfolioManagement,
          // JSON.stringify(filer),
          province,
          taxStatus,
          joint_h_1_taxStatus,
          joint_h_2_taxStatus,
          joint_h_2_taxStatus,
          cdc_IAS,
          cdc_subAccount,
          cdc_participantID,
          salesInHouse?.toString(),
          salesCompany,
          salesPerson,
          riskFactor,
          DOB,
          calculateAge?.toString(),
          profilePicture,
          systematicInvestment,
          unitholderType,
          lifetimeCNIC?.toString(),
          joiningDate,
          employeeNominee,
          leavingDate,
        );
        if (response.data.status == 200) {
          toast.success(response.data.message);
          setTimeout(() => {
            history.replace(`/admin/unit-holders`);
          }, 2000);
        } else {
          setLoading(false);
          toast.error(response.data.message?.toString());
        }
      } catch (error: any) {
        setLoading(false);
        if (error.response) {
          toast.error(error.response.data.message?.toString());
        } else {
          toast.error("Request Failed");
        }
      }
    }
  };
  //render Fund table data
  const renderFundDataInTable = () => {
    return totalFunds.map((items: any, index: number) => {
      return (
        <tr key={index}>
          <td>{items.fund_name ? items.fund_name : items.fund_code}</td>
          <td>
            {items.fund_unit.toString().split(".")[1]
              ? numberWithCommas(items.fund_unit.toString().split(".")[0]) +
                "." +
                items.fund_unit.toString().split(".")[1]
              : numberWithCommas(items.fund_unit)}
          </td>
        </tr>
      );
    });
  };

  const selectedCity = React.useMemo(() => {
    return city
      ? {
          value: city,
          label: city,
        }
      : null;
  }, [city]);

  const selectedInvestorType = React.useMemo(() => {
    return type
      ? {
          value: type,
          label: type,
        }
      : null;
  }, [type]);

  const selectedPortfolio = React.useMemo(() => {
    const selectedFund =
      portfolioArr &&
      portfolioArr?.find((item) => item?.value === portfolioManagement);
    return selectedFund
      ? {
          value: selectedFund.value,
          label: selectedFund.label,
        }
      : null;
  }, [portfolioArr, portfolioManagement]);

  const selectedTaxStatus = React.useMemo(() => {
    return taxStatus
      ? {
          value: taxStatus,
          label: taxStatus,
        }
      : null;
  }, [taxStatus]);

  const selectedTerritory = React.useMemo(() => {
    return province
      ? {
          value: province,
          label: province,
        }
      : null;
  }, [province]);

  const selectedBankName = React.useMemo(() => {
    const selectedFund =
      bankNameData &&
      bankNameData?.find(
        (item) => item.bank_code.replace("BANK_", "") === bankname,
      );
    if (selectedFund) {
      return {
        value: selectedFund.bank_code.replace("BANK_", ""),
        label: `${selectedFund.bank_name} (${selectedFund.bank_code.replace(
          "BANK_",
          "",
        )})`,
      };
    } else if (bankname === "Other") {
      return { label: "Other", value: "Other" };
    } else {
      return null;
    }
  }, [bankNameData, bankname]);

  const selectedIncomeTaxStatus = React.useMemo(() => {
    return joint_h_1_taxStatus
      ? {
          value: joint_h_1_taxStatus,
          label: joint_h_1_taxStatus,
        }
      : null;
  }, [joint_h_1_taxStatus]);

  const selectedIncomeTax2Status = React.useMemo(() => {
    return joint_h_2_taxStatus
      ? {
          value: joint_h_2_taxStatus,
          label: joint_h_2_taxStatus,
        }
      : null;
  }, [joint_h_2_taxStatus]);

  const selectedIncomeTax3Status = React.useMemo(() => {
    return joint_h_3_taxStatus
      ? {
          value: joint_h_3_taxStatus,
          label: joint_h_3_taxStatus,
        }
      : null;
  }, [joint_h_3_taxStatus]);

  const selectedSalesCompany = React.useMemo(() => {
    const selectedFund =
      allSalesCompany &&
      allSalesCompany?.find((item) => item?.company_code === salesCompany);
    return selectedFund
      ? {
          value: selectedFund.company_code,
          label: selectedFund.company_name,
        }
      : null;
  }, [allSalesCompany, salesCompany]);

  const selectedRiskFactor = React.useMemo(() => {
    return riskFactor
      ? {
          value: riskFactor,
          label: riskFactor,
        }
      : null;
  }, [riskFactor]);

  const selectedSalesPerson = React.useMemo(() => {
    const selectedFund =
      allSalesCompany &&
      allSalesCompany
        ?.filter((ele) => ele?.company_code == salesCompany)[0]
        ?.persons?.find((item) => item?.id == salesPerson);
    return selectedFund
      ? {
          value: selectedFund.id,
          label: `${selectedFund.name}(${selectedFund.email})`,
        }
      : null;
  }, [allSalesCompany, salesPerson]);

  const selectedParentFund = React.useMemo(() => {
    const selectedFund =
      allFunds && allFunds?.find((item) => item?.symbol_code === fund);
    return selectedFund
      ? {
          value: selectedFund.symbol_code,
          label: `${selectedFund.fund_name} (${selectedFund.symbol_code})`,
        }
      : null;
  }, [allFunds, fund]);

  const selectedUnitholderType = React.useMemo(() => {
    return unitholderType
      ? {
          value: unitholderType,
          label: unitholderType,
        }
      : null;
  }, [unitholderType]);

  const selectedSystematicVPSType = React.useMemo(() => {
    return typeVPS
      ? {
          value: typeVPS,
          label: typeVPS,
        }
      : null;
  }, [typeVPS]);

  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      background: isFocused
        ? "hsla(291, 64%, 42%, 0.5)"
        : isSelected
          ? "hsla(291, 64%, 42%, 1)"
          : undefined,
      zIndex: 1,
    }),
    menuList: (styles) => ({
      ...styles,
      background: theme == "dark" ? "#3b3b3b" : "#ffffff",
      color: theme == "dark" ? "white" : "",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
    control: (base, state) => ({
      ...base,
      background: theme == "dark" ? "#25273a" : "#f2f2f2",
      borderRadius: "0.4285rem",
      borderColor: state.isFocused
        ? "#1d8cf8"
        : theme !== "light"
          ? "#2b3553"
          : "",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "" : "#ba54f5",
      },
      '& .react-select__input input[type="color"]': {
        color: theme === "dark" ? "red" : "black",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme == "dark" ? "white" : "black",
    }),
    input: (base) => ({
      ...base,
      color: theme == "dark" ? "white" : "black",
    }),
  };

  // ---------------- below in updated UI --------------------

  const renderRange = (ValueIs) => {
    const filteredType = typeRatioSystematic?.find(
      (ele) => ele?.label === typeVPS,
    );
    if (filteredType && ValueIs) {
      return filteredType.ratio[ValueIs] || "";
    }
    return "";
  };

  const calculateBlockTotal = (subFunds, key = "proportion") => {
    return subFunds.reduce((total, fund) => {
      const proportion = parseFloat(fund[key]) || 0;
      return total + proportion;
    }, 0);
  };

  const removeSubFundsBlock = (blockId) => {
    if (subFundsBlocks.length > 1) {
      setSubFundsBlocks(subFundsBlocks.filter((block) => block.id !== blockId));
    }
  };

  const updateParentFund = (blockId, selectedFund) => {
    if (!typeVPS) {
      toast.error("kindly select Type first");
      return;
    }

    setSubFundsBlocks((prevBlocks) =>
      prevBlocks.map((block) => {
        if (block.id === blockId) {
          let subFund = allFunds?.find(
            (ele) => ele?.symbol_code === selectedFund?.value,
          )?.child_fund;
          return {
            ...block,
            selectedParentFund: selectedFund,
            fund: selectedFund?.value || null,
            parentProportion: 0,
            total_amount: 0,
            // subFunds: block.subFunds.map(subFund => ({ ...subFund, proportion: '' })) // Reset sub-fund proportions
            subFunds: subFund
              ? subFund?.map((subFund, i) => {
                  let findItem = allFunds?.find((ele) => ele?._id == subFund);
                  return {
                    id: i + 1,
                    name: findItem?.fund_name || "",
                    proportion: "0.00",
                    amount: "0.00",
                    type_VPS: findItem?.nature || "",
                  };
                })
              : [],
          };
        }
        return block;
      }),
    );
  };

  const updateProportion = (blockId, fundIndex, newValue) => {
    setSubFundsBlocks((prevBlocks) =>
      prevBlocks.map((block) => {
        if (block.id === blockId) {
          const updatedSubFunds: any = [...block.subFunds];

          const otherFundsTotal = updatedSubFunds.reduce(
            (total, fund, index) => {
              if (index !== fundIndex) {
                return total + (parseFloat(fund.proportion) || 0);
              }
              return total;
            },
            0,
          );

          const newValueNum = parseFloat(newValue) || 0;

          if (otherFundsTotal + newValueNum > 100) {
            return block;
          }

          updatedSubFunds[fundIndex].proportion = newValue;
          const newAmount =
            amount * (updatedSubFunds[fundIndex].proportion / 100);
          updatedSubFunds[fundIndex].amount = newAmount;

          const newBlockTotal = calculateBlockTotal(updatedSubFunds);

          const newBlockAmountTotal = calculateBlockTotal(
            updatedSubFunds,
            "amount",
          );
          return {
            ...block,
            subFunds: updatedSubFunds,
            parentProportion: newBlockTotal,
            total_amount: newBlockAmountTotal,
          };
        }
        return block;
      }),
    );
  };
  const onAmountChange = () => {
    if (subFundsBlocks.length < 1) return;

    setSubFundsBlocks((prevBlocks) =>
      prevBlocks.map((block: any) => {
        if (block.subFunds.length < 1) return block;
        const updatedSubFunds = block.subFunds.map((fund: any) => {
          if (fund.proportion <= 0) return fund;

          fund.amount = amount * (parseFloat(fund.proportion) / 100);

          return fund;
        });

        block.total_amount = calculateBlockTotal(updatedSubFunds, "amount");

        return block;
      }),
    );
  };
  React.useEffect(() => {
    if (amount > 0) onAmountChange();
  }, [amount]);

  const setIndexedError = (index: number, message: string | null) => {
    setErrors((prevErrors) => {
      if (!message) {
        const { [index]: removed, ...rest } = prevErrors;
        return rest;
      }
      return { ...prevErrors, [index]: message };
    });
  };
  // Helper function for range validation
  const validateFundProportionRange = (
    proportion: number | string,
    type_VPS: string,
  ): { valid: boolean; error: string | null } => {
    if (proportion === "" || proportion === null || proportion === undefined) {
      return { valid: true, error: null };
    }
    const numValue =
      typeof proportion === "string" ? parseFloat(proportion) : proportion;
    if (isNaN(numValue)) return { valid: false, error: "Invalid value" };

    const range = renderRange(type_VPS); // e.g. "10-25%"
    if (!range) return { valid: true, error: null };
    const [min, max] = range.replace("%", "").split("-").map(Number);

    if (numValue < 0 || numValue > 100) {
      return { valid: false, error: `Value must be between 0 and 100.` };
    }
    if (numValue > max) {
      return {
        valid: false,
        error: `Value must be between ${min}% and ${max}%`,
      };
    }
    if (numValue < min) {
      return {
        valid: false,
        error: `Value must be between ${min}% and ${max}%`,
      };
    }
    return { valid: true, error: null };
  };

  // Usage in useEffect when allocation scheme changes
  React.useEffect(() => {
    if (typeVPS && subFundsBlocks.length > 0) {
      subFundsBlocks.forEach((block, blockIndex) => {
        block.subFunds?.forEach((fund, fundIndex) => {
          const { valid, error } = validateFundProportionRange(
            fund.proportion,
            fund.type_VPS,
          );
          setIndexedError(fundIndex, error);
          if (!valid && error) {
            toast.error(error);
          }
        });
      });
    }
    // eslint-disable-next-line
  }, [typeVPS]);

  const isAllowedInvestProporation = (values, ele, fundIndex) => {
    const { value } = values;

    if (value === "") {
      if (rangeTimer) clearTimeout(rangeTimer);
      setIndexedError(fundIndex, null); // <--- Clear error on empty
      return true;
    }

    const numValue = parseFloat(value);

    // 1. Overall bounds check (0-100)
    if (numValue < 0 || numValue > 100) {
      setIndexedError(fundIndex, `Value must be between 0 and 100.`); // <--- Set error
      return false;
    }

    const range = renderRange(ele?.type_VPS); // e.g. "10-25%"
    const [min, max] = range.replace("%", "").split("-").map(Number);
    const rangeErrorMsg = `Value must be between ${min}% and ${max}%`;

    // 2. Immediate check for greater than max
    if (numValue > max) {
      setIndexedError(fundIndex, rangeErrorMsg); // <--- Set error
      return false;
    }

    // 3. Immediate check for single-digit minimums
    if (value.length === 1 && numValue < min && min <= 9) {
      setIndexedError(fundIndex, rangeErrorMsg); // <--- Set error
      return false;
    }

    // Clear any previous error before the delayed check
    setIndexedError(fundIndex, null);

    // Existing delayed check for min
    if (rangeTimer) clearTimeout(rangeTimer);

    const newTimer = setTimeout(() => {
      if (numValue < min) {
        toast.error(rangeErrorMsg);
        setIndexedError(fundIndex, rangeErrorMsg); // <--- Set error state after timeout
      } else {
        setIndexedError(fundIndex, null); // <--- Clear error after timeout if valid
      }
    }, 800);

    setRangeTimer(newTimer);
    return true; // Allow the input unless blocked above
  };

  const handleCustomCheckboxChange = (
    blockId: any,
    fundIndex: any,
    isChecked: any,
  ) => {
    setSubFundsBlocks((prevBlocks: any) =>
      prevBlocks.map((block: any) => {
        if (block.id !== blockId || !block.subFunds) {
          return block;
        }

        const updatedSubFunds: any = block.subFunds.map((fund, index) => {
          if (index === fundIndex) {
            // Update the clicked fund
            const newProportion = isChecked ? "100" : "0";
            const newAmount = isChecked ? amount : "0";
            return { ...fund, proportion: newProportion, amount: newAmount };
          } else if (isChecked) {
            // If the current fund is checked, all others become 0
            return { ...fund, proportion: "0", amount: "0" };
          }
          // If unchecking, other funds' proportions remain as they were,
          // but the current fund is the only one set to 0.
          return fund;
        });

        // Calculate the new parentProportion total for the block
        const newBlockTotal = calculateBlockTotal(updatedSubFunds);
        const newBlockAmountTotal = calculateBlockTotal(
          updatedSubFunds,
          "amount",
        );

        return {
          ...block,
          subFunds: updatedSubFunds,
          parentProportion: newBlockTotal,
          total_amount: newBlockAmountTotal,
        };
      }),
    );
  };

  const handleRemoveEmployeeNominee = () => {
    let temp = [...employeeNominee];
    temp.pop();
    setEmployeeNominee(temp);
  };

  const handleAddEmployeeNominee = () => {
    let temp = [...employeeNominee];
    temp.push({
      nominee_name: "",
      nominee_relation: "",
      nominee_cnic: "",
    });
    setEmployeeNominee(temp);
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />
              {/* <Header />	 */}
              <div className="input-holder">
                <h4 className="card-title">Edit - Unit Holder</h4>
                <Link
                  to="/admin/unit-holders"
                  className="t-3 ml-auto btn btn-primary btn-sm"
                  replace
                >
                  <i className="fa fa-eye mr-2"></i> View All
                </Link>
              </div>

              <Row>
                <Col md="4">
                  <Card>
                    <CardHeader>
                      <CardTitle tag="h4">Registration</CardTitle>
                    </CardHeader>
                    <CardBody>
                      <div className="form-group">
                        <label>Type</label>
                        <div>
                          <Select
                            value={selectedUnitholderType}
                            label={"Select Type"}
                            isDisabled
                            onChange={(e) => {
                              setSubFundsBlocks([
                                {
                                  id: 1,
                                  selectedParentFund: null,
                                  fund: null,
                                  parentProportion: 0,
                                  total_amount: 0,
                                  subFunds: [],
                                },
                              ]);
                              setAmount("");
                              setTypeVPS("");
                              setErrors({});
                              setUnitholderType(e?.value);
                            }}
                            menuPortalTarget={document.body}
                            menuShouldBlockScroll={true}
                            isClearable={true}
                            isSearchable={true}
                            name="color"
                            options={renderUniholderType()}
                            styles={customStyles}
                          />
                        </div>
                      </div>

                      <div className="form-group  ">
                        {/* <label>Folio No</label> */}
                        <label>Employee No</label>
                        <div>
                          {unitholderType === "Employee" ? (
                            <input
                              type="text"
                              className={`form-control w-100`}
                              value={employeeId}
                              readOnly
                            />
                          ) : (
                            <input
                              type="text"
                              className={`form-control  w-100 ${
                                folioNoError ? "required-border" : ""
                              }`}
                              value={folioNo}
                              readOnly
                              onChange={(e) => {
                                setFolioNo(e.target.value.toUpperCase());
                                setFolioNoError("");
                              }}
                            />
                          )}
                          {/* {folioNoError ? <p className="error-labels error-message2">{folioNoError}</p> : ''} */}
                        </div>
                      </div>
                      {(unitholderType == "" ||
                        unitholderType !== "Employee") && (
                        <>
                          <Row>
                            <Col md="6">
                              <div className="form-group">
                                <label>Investor Type</label>
                                <div>
                                  <Select
                                    value={selectedInvestorType}
                                    label={"Select Type"}
                                    isDisabled
                                    onChange={(e) => {
                                      setType(e?.value);
                                    }}
                                    menuPortalTarget={document.body}
                                    menuShouldBlockScroll={true}
                                    isClearable={true}
                                    isSearchable={true}
                                    name="color"
                                    options={renderTypeDropdown}
                                    styles={customStyles}
                                  />
                                  {/* <select
                                className={`form-control  w-100`}
                                value={type}
                                onChange={(e) => {
                                  setType(e.target.value);
                                }}
                                disabled
                              >
                                <option value="" defaultChecked hidden>
                                  Select Type
                                </option>
                                <option value="Individual">Individual</option>
                                <option value="Corporate">Corporate</option>
                              </select> */}
                                </div>
                              </div>
                            </Col>
                            <Col md="6">
                              <div className="form-group">
                                <label>Portfolio Management</label>
                                <div>
                                  <Select
                                    value={selectedPortfolio}
                                    label={"Select Fund"}
                                    onChange={(e) => {
                                      setPortfolioManagement(e?.value);
                                    }}
                                    menuPortalTarget={document.body}
                                    menuShouldBlockScroll={true}
                                    isClearable={true}
                                    isSearchable={true}
                                    name="color"
                                    options={portfolioArr}
                                    styles={customStyles}
                                  />
                                  {/* <select
                                className={`form-control  w-100`}
                                value={portfolioManagement}
                                onChange={(e) => {
                                  setPortfolioManagement(e.target.value);
                                }}
                              >
                                <option value="" defaultChecked hidden>
                                  Fund
                                </option>
                                <option value="fund">Fund</option>
                                <option value="sma">SMA</option>
                              </select> */}
                                </div>
                              </div>
                            </Col>
                          </Row>

                          <div className="form-group">
                            <label>Tax Status</label>
                            <Select
                              value={selectedTaxStatus}
                              label={"Select Tax Type"}
                              onChange={(e) => {
                                setTaxStatus(e?.value);
                              }}
                              menuPortalTarget={document.body}
                              menuShouldBlockScroll={true}
                              isClearable={true}
                              isSearchable={true}
                              name="color"
                              options={taxStatusArr}
                              styles={customStyles}
                            />
                            {/* <select
                          className="form-control"
                          value={taxStatus}
                          onChange={(e) => {
                            setTaxStatus(e.target.value);
                          }}
                        >
                          <option value="" hidden>
                            {" "}
                            Select Tax Type
                          </option>
                          <option value="Filer">Filer</option>
                          <option value="Non-Filer">Non-Filer</option>
                          <option value="Exempted">Exempted</option>
                        </select> */}
                          </div>

                          <div className="d-flex justify-content-between mt-4 pb-3">
                            <div className="form-group d-flex">
                              <ToggleButton
                                inactiveLabel=""
                                activeLabel=""
                                value={zakat_exempt}
                                thumbStyle={borderRadiusStyle}
                                trackStyle={borderRadiusStyle}
                                onToggle={() => {
                                  if (zakat_exempt) {
                                    setZakat_exempt(false);
                                  } else {
                                    setZakat_exempt(true);
                                  }
                                }}
                              />
                              <label className="ml-2 mt-2">Zakat Exempt</label>
                            </div>

                            <div className="form-group d-flex">
                              <FormGroup check>
                                <Label check>
                                  <Input
                                    type="checkbox"
                                    checked={reinvestCheck}
                                    onChange={(e) => {
                                      setReinvestCheck(!reinvestCheck);
                                    }}
                                  />
                                  <span className="form-check-sign" />
                                  Fund Dividend Reinvest
                                </Label>
                              </FormGroup>
                            </div>
                          </div>
                        </>
                      )}

                      {JSON.parse(sessionStorage.getItem("clientObj") || "{}")
                        ?.investor_id && (
                        <button
                          className="t-3 ml-auto btn btn-primary btn-sm"
                          onClick={async () => {
                            try {
                              const response = await getInvestorByID(
                                email,
                                amcName,
                                JSON.parse(
                                  sessionStorage.getItem("clientObj") || "{}",
                                )?.investor_id,
                              );
                              if (response.data.status == 200) {
                                sessionStorage.setItem(
                                  "investorObj",
                                  JSON.stringify(response.data.data),
                                );
                                history.replace(
                                  "/admin/view-potential-investor",
                                );
                              } else {
                                toast.error(response.data.message);
                              }
                            } catch (error: any) {
                              toast.error(
                                error.response.data.message?.toString() ||
                                  error?.message ||
                                  "Request Failed",
                              );
                            }
                          }}
                        >
                          <i className="fa fa-eye mr-2"></i> View Potential
                          Investor
                        </button>
                      )}
                    </CardBody>
                  </Card>
                </Col>

                <Col md="4">
                  <Card>
                    <CardHeader>
                      <CardTitle tag="h4">Personal Details</CardTitle>
                    </CardHeader>
                    <CardBody>
                      <div className="d-flex justify-content-center">
                        <div
                          style={{
                            width: "100px",
                            height: "100px",
                            position: "relative",
                          }}
                          onMouseEnter={() => setOnhover(true)}
                          onMouseLeave={() => setOnhover(false)}
                        >
                          {showImage ? (
                            <img
                              style={{
                                width: "100px",
                                height: "100px",
                              }}
                              className="User_image"
                              src={image}
                            />
                          ) : (
                            <svg
                              style={{
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                if (inputRefUser.current) {
                                  inputRefUser.current.click();
                                }
                              }}
                              xmlns="http://www.w3.org/2000/svg"
                              width="100"
                              height="100"
                              viewBox="0 0 50 50"
                            >
                              <path
                                fill="#949494"
                                d="M25 2.008c-12.69 0-23 10.31-23 23s10.31 23 23 23 23-10.31 23-23-10.31-23-23-23m0 2c11.61 0 21 9.39 21 21a20.92 20.92 0 0 1-6.012 14.705c-1.83-1.343-4.06-2.017-5.949-2.69-1.064-.378-2.02-.753-2.719-1.171-.668-.4-1.04-.813-1.236-1.286-.092-1.146-.073-2.07-.066-3.16.12-.12.276-.205.4-.351.292-.345.59-.764.873-1.235.487-.807.84-1.795 1.04-2.797.302-.154.626-.187.872-.502.455-.58.762-1.396.899-2.533.12-1.004-.203-1.694-.62-2.224.449-1.465 1.003-3.795.815-6.205-.104-1.327-.438-2.662-1.24-3.772-.767-1.06-2.011-1.822-3.604-2.098C28.442 8.541 26.835 8 24.914 8h-.018c-4.302.079-7.078 1.86-8.267 4.576-1.13 2.583-.887 5.799-.076 9.147-.436.53-.778 1.233-.655 2.265.137 1.137.444 1.954.899 2.533.246.315.57.348.873.502.198 1.001.552 1.988 1.039 2.795.284.471.58.89.873 1.235.124.146.28.233.4.353.007 1.09.025 2.013-.066 3.16-.196.472-.567.884-1.234 1.286-.698.42-1.653.797-2.715 1.177-1.887.677-4.116 1.355-5.951 2.688A20.92 20.92 0 0 1 4 25.007c0-11.609 9.39-21 21-21m-.078 5.994c1.844.002 3.004.548 3.322 1.105l.244.428.487.067c1.256.174 1.958.662 2.46 1.357.503.695.783 1.666.868 2.756.17 2.18-.454 4.754-.85 5.945l-.252.756.682.414c-.07-.042.32.189.232.92-.106.89-.334 1.343-.486 1.537s-.218.17-.201.168l-.824.068-.088.823c-.076.706-.473 1.67-.938 2.441a8 8 0 0 1-.687.975c-.208.245-.43.397-.346.353l-.535.28V31c0 1.324-.054 2.407.086 3.95l.011.132.047.125c.394 1.06 1.215 1.806 2.139 2.36s1.983.952 3.076 1.341c1.801.641 3.678 1.272 5.11 2.203A20.9 20.9 0 0 1 25 46.008c-5.134 0-9.829-1.84-13.475-4.893 1.44-.926 3.32-1.559 5.118-2.203 1.092-.391 2.149-.793 3.07-1.348.921-.554 1.74-1.301 2.133-2.357l.047-.125.011-.133c.139-1.54.086-2.624.086-3.949v-.605l-.535-.282c.084.044-.138-.108-.346-.353a8 8 0 0 1-.687-.973c-.465-.771-.862-1.736-.938-2.441l-.088-.823-.824-.068c.016.001-.049.026-.2-.168-.153-.194-.38-.647-.487-1.537-.088-.732.307-.965.232-.92l.635-.385-.186-.72c-.86-3.312-.99-6.325-.105-8.348.884-2.02 2.655-3.303 6.46-3.375"
                              ></path>
                            </svg>
                          )}
                          {onhover && (
                            <div
                              style={{
                                width: "100px",
                                height: "100px",
                                borderRadius: "50%",
                                backgroundColor: "rgba(0,0,0.4)",
                                opacity: 0.6,
                                position: "absolute",
                                top: "0px",
                                left: "0px",
                              }}
                              className="d-flex flex-column align-items-center justify-content-center"
                            >
                              {showImage && (
                                <IoClose
                                  style={{
                                    width: "25px",
                                    height: "25px",
                                    cursor: "pointer",
                                    color: "white",
                                  }}
                                  onClick={() => {
                                    setShowImage(false);
                                    if (inputRefUser.current) {
                                      inputRefUser.current.value = "";
                                    }
                                    setProfilePicture("");
                                  }}
                                  className="mb-2"
                                />
                              )}
                              <FiUploadCloud
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  cursor: "pointer",
                                  color: "white",
                                }}
                                onClick={() => {
                                  if (inputRefUser.current) {
                                    inputRefUser.current.click();
                                  }
                                }}
                              />
                            </div>
                          )}
                        </div>
                        <input
                          type="file"
                          // accept="image/png, image/jpeg, image/jpg"
                          accept=".jpg,.jpeg,.png"
                          ref={inputRefUser}
                          onChange={(event) => {
                            const reader = new FileReader();
                            reader.onload = () => {
                              setImage(reader.result);
                              setShowImage(true);
                            };
                            if (event.target.files) {
                              let file = event.target.files[0];
                              if (file) {
                                let type = file.name
                                  .substring(file.name.lastIndexOf(".") + 1)
                                  ?.toLowerCase();
                                let imgSize = file.size;
                                if (imgSize > 1048576) {
                                  toast.error(
                                    "Image size should be less than 1MB",
                                  );
                                } else if (
                                  type === "png" ||
                                  type === "jpg" ||
                                  type === "jpeg"
                                ) {
                                  setProfilePicture(event.target.files[0]);
                                  reader.readAsDataURL(event.target.files[0]);
                                } else {
                                  toast.error("Invalid Format");
                                }
                              }
                            }
                          }}
                          style={{ display: "none" }}
                        />
                      </div>

                      <div className="form-group  ">
                        <label>Client Name</label>
                        <div>
                          <input
                            type="text"
                            className={`form-control  w-100 ${
                              nameError ? "required-border" : ""
                            }`}
                            value={name}
                            onChange={(e) => {
                              setName(e.target.value);
                              setNameError("");
                            }}
                          />
                          {/* {nameError ? <p className="error-labels error-message">{nameError}</p> : ''} */}
                        </div>
                      </div>
                      {(type == "Individual" ||
                        type == "Individuals" ||
                        unitholderType === "Employee") && (
                        <>
                          <div className="form-group">
                            <label>DOB </label>
                            <div>
                              <input
                                type="date"
                                value={DOB}
                                className={`form-control ${
                                  theme == "dark" ? "input_date" : ""
                                }`}
                                onChange={(e) => {
                                  setDOB(e.target.value);
                                  setCalculateAge(
                                    moment().diff(e.target.value, "years") ||
                                      "",
                                  );
                                }}
                              />
                            </div>
                          </div>
                          {unitholderType !== "Employee" && (
                            <>
                              <div className="form-group">
                                <label>Age </label>
                                <div>
                                  <input
                                    disabled
                                    type="text"
                                    value={calculateAge}
                                    className="form-control "
                                  />
                                </div>
                              </div>
                              <div className="form-group">
                                <label>Risk Factor </label>
                                <div>
                                  <Select
                                    value={selectedRiskFactor}
                                    label={"Select"}
                                    onChange={(e) => {
                                      setRiskFactor(e?.value);
                                    }}
                                    menuPortalTarget={document.body}
                                    menuShouldBlockScroll={true}
                                    isClearable={true}
                                    isSearchable={true}
                                    name="color"
                                    options={riskFactorOpt}
                                    styles={customStyles}
                                  />
                                </div>
                              </div>
                              <div className="form-group">
                                <label>Father/Spouse Name</label>
                                <div className="">
                                  <input
                                    type="text"
                                    className={"form-control  w-100"}
                                    value={father}
                                    onChange={(e) => {
                                      setFather(e.target.value);
                                    }}
                                  />
                                </div>
                              </div>
                            </>
                          )}
                          {unitholderType === "Employee" && (
                            <>
                              <div className="form-group">
                                <label>Joining Date</label>
                                <div>
                                  <input
                                    type="date"
                                    value={joiningDate}
                                    className={`form-control ${
                                      theme == "dark" ? "input_date" : ""
                                    }`}
                                    onChange={(e) => {
                                      setJoiningDate(e.target.value);
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="form-group">
                                <label>Leaving Date</label>
                                <div>
                                  <input
                                    type="date"
                                    value={leavingDate}
                                    className={`form-control ${
                                      theme == "dark" ? "input_date" : ""
                                    }`}
                                    onChange={(e) => {
                                      setLeavingDate(e.target.value);
                                    }}
                                  />
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      )}

                      {(type == "Individual" ||
                        type == "Individuals" ||
                        unitholderType === "Employee") && (
                        <Row>
                          <Col md="12" xl="6">
                            <div className="form-group  ">
                              <div className="d-flex justify-content-between align-items-end">
                                <label>CNIC</label>
                                <FormGroup className="mb-1" check>
                                  <Label check>
                                    <Input
                                      type="checkbox"
                                      checked={lifetimeCNIC}
                                      onChange={(e) => {
                                        setLifetimeCNIC(!lifetimeCNIC);
                                        if (e.target.checked) {
                                          setCnicExpiry("");
                                          setCnicExpiryError("");
                                        }
                                      }}
                                    />
                                    <span className="form-check-sign" />
                                    Lifetime CNIC
                                  </Label>
                                </FormGroup>
                              </div>
                              <div>
                                {/* <input	
                          type="text"	
                          className={`form-control  w-100 ${	
                            cnicError ? 'required-border' : ''	
                          }`}	
                          value={cnic}	
                          onChange={(e) => {	
                            setCnic(e.target.value);	
                            setCnicError('');	
                          }}	
                        />	 */}

                                <InputMask
                                  className={`form-control  w-100 ${
                                    cnicError ? "required-border" : ""
                                  }`}
                                  mask="99999-9999999-9"
                                  value={cnic}
                                  // readOnly
                                  onChange={(e) => {
                                    setCnic(e.target.value);
                                    setCnicError("");
                                  }}
                                ></InputMask>
                                {/* {cnicError ? <p className="error-labels error-message">{cnicError}</p> : ''} */}
                              </div>
                            </div>
                          </Col>

                          <Col md="12" xl="6">
                            <div className="form-group  ">
                              <label>CNIC Expiry</label>
                              <div>
                                <input
                                  style={{
                                    colorScheme:
                                      theme == "light" ? "light" : "dark",
                                  }}
                                  disabled={lifetimeCNIC}
                                  type="date"
                                  className={`form-control  w-100 ${
                                    cnicExpiryError ? "required-border" : ""
                                  }`}
                                  value={moment(cnicExpiry).format(
                                    "YYYY-MM-DD",
                                  )}
                                  onChange={(e) => {
                                    setCnicExpiry(e.target.value);
                                    setCnicExpiryError("");
                                  }}
                                />
                                {/* {cnicExpiryError ? <p className="error-labels error-message2">{cnicExpiryError}</p> : ''} */}
                              </div>
                            </div>
                          </Col>
                        </Row>
                      )}

                      {type === "Corporate" && (
                        <div className="form-group  ">
                          <label>NTN</label>
                          <div>
                            <input
                              type="number"
                              className={`form-control  w-100 ${
                                ntnError ? "required-border" : ""
                              }`}
                              value={ntn}
                              // readOnly
                              onChange={(e) => {
                                setNtn(e.target.value);
                                setNtnError("");
                              }}
                            />
                            {/* {ntnError ? <p className="error-labels error-message">{ntnError}</p> : ''} */}
                          </div>
                        </div>
                      )}
                    </CardBody>
                  </Card>
                </Col>

                <Col md="4">
                  <Card>
                    <CardHeader>
                      <CardTitle tag="h4">Contact</CardTitle>
                    </CardHeader>
                    <CardBody>
                      <div className="form-group  ">
                        <label>Email</label>
                        <div>
                          <input
                            type="text"
                            className={`form-control  w-100 ${
                              clientEmailError ? "required-border" : ""
                            }`}
                            value={clientEmail}
                            onChange={(e) => {
                              setClientEmail(e.target.value);
                              setClientEmailError("");
                            }}
                          />
                          {/* {clientEmailError ? <p className="error-labels error-message2">{clientEmailError}</p> : ''} */}
                        </div>
                      </div>

                      <Row>
                        <Col md="6">
                          <div className="form-group  ">
                            <label>Mobile</label>
                            <div>
                              {/* <input	
                        type="number"	
                        className={`form-control  w-100 ${	
                          mobileError ? 'required-border' : ''	
                        }`}	
                        value={mobile}	
                        onChange={(e) => {	
                          setMobile(e.target.value);	
                          setMobileError('');	
                        }}	
                      />	 */}
                              <PhoneInput
                                specialLabel=""
                                inputClass={`form-control  w-100 ${
                                  mobileError ? "required-border" : ""
                                }`}
                                country={"pk"}
                                placeholder="+92 123-1234567"
                                value={mobile}
                                onChange={(e) => {
                                  setMobile(e);
                                  setMobileError("");
                                }}
                              />

                              {/* {mobileError ? <p className="error-labels error-message">{mobileError}</p> : ''} */}
                            </div>
                          </div>
                        </Col>

                        <Col md="6">
                          <div className="form-group  ">
                            <label>Phone</label>
                            <div>
                              {/* <input	
                        type="number"	
                        className={`form-control  w-100 ${	
                          phoneError ? 'required-border' : ''	
                        }`}	
                        value={phone}	
                        onChange={(e) => {	
                          setPhone(e.target.value);	
                          setPhoneError('');	
                        }}	
                      />	 */}
                              <PhoneInput
                                specialLabel=""
                                inputClass={`form-control  w-100 ${
                                  phoneError ? "required-border" : ""
                                }`}
                                country={"pk"}
                                placeholder="+92 123-1234567"
                                value={phone}
                                onChange={(e) => {
                                  setPhone(e);
                                  setPhoneError("");
                                }}
                              />
                              {/* {phoneError ? <p className="error-labels error-message2">{phoneError}</p> : ''} */}
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <div className="form-group  ">
                        <label>Address</label>
                        <div>
                          <input
                            type="text"
                            className={`form-control  w-100 ${
                              addressError ? "required-border" : ""
                            }`}
                            value={address}
                            onChange={(e) => {
                              setAddress(e.target.value);
                              setAddressError("");
                            }}
                          />
                          {/* {addressError ? <p className="error-labels error-message">{addressError}</p> : ''} */}
                        </div>
                      </div>

                      <Row>
                        <Col>
                          <div className="form-group  ">
                            <label>City</label>
                            <div>
                              <Select
                                className={`${
                                  cityError ? "required-border" : ""
                                }`}
                                value={selectedCity}
                                label={"Select City"}
                                onChange={(e) => {
                                  setCityError("");
                                  setCity(e?.value);
                                }}
                                menuPortalTarget={document.body}
                                menuShouldBlockScroll={true}
                                isClearable={true}
                                isSearchable={true}
                                name="color"
                                options={renderCitiesDropdown()}
                                styles={customStyles}
                              />
                              {/* <select
                                className={`form-control  w-100 ${cityError ? "required-border" : ""
                                  }`}
                                value={city}
                                onChange={(e) => {
                                  setCityError("");
                                  setCity(e.target.value);
                                }}
                              >
                                <option value="" defaultChecked hidden>
                                  {" "}
                                  Select City
                                </option>
                                {renderCitiesDropdown()}
                              </select> */}
                              {/* {cityError ? <p className="error-labels error-message2">{cityError}</p> : ''} */}
                            </div>
                          </div>
                        </Col>
                        <Col>
                          <div className="form-group">
                            <label>Territories</label>
                            <div>
                              <Select
                                className={`${
                                  provinceError ? "required-border" : ""
                                }`}
                                value={selectedTerritory}
                                label={"Select Territory"}
                                onChange={(e) => {
                                  setProvince(e?.value);
                                }}
                                menuPortalTarget={document.body}
                                menuShouldBlockScroll={true}
                                isClearable={true}
                                isSearchable={true}
                                name="color"
                                options={renderCitiesDropdown()}
                                styles={customStyles}
                              />
                              {/* <select
                                className={`form-control  w-100 ${provinceError ? "required-border" : ""
                                  }`}
                                value={province}
                                onChange={(e) => {
                                  setProvince(e.target.value);
                                }}
                              >
                                <option value="" defaultChecked hidden>
                                  Select
                                </option>
                                <option value="Islamabad">Islamabad</option>
                                <option value="Punjab">Punjab</option>
                                <option value="Khyber Pakhtunkhwa">
                                  Khyber Pakhtunkhwa
                                </option>
                                <option value="Balochistan">Balochistan</option>
                                <option value="Sindh">Sindh</option>
                                <option value="Gilgit Baltistan">
                                  Gilgit Baltistan
                                </option>
                                <option value="Azad Jammu and Kashmir">
                                  Azad Jammu and Kashmir
                                </option>
                              </select> */}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>

                <Col md="4">
                  <Card>
                    <CardHeader>
                      <CardTitle tag="h4">Bank Account Detail</CardTitle>
                    </CardHeader>
                    <CardBody>
                      <div className="form-group  ">
                        <label>Account Title</label>
                        <div>
                          <input
                            type="text"
                            className={`form-control  w-100 ${
                              accTitleError ? "required-border" : ""
                            }`}
                            value={accTitle}
                            onChange={(e) => {
                              if (
                                e.target.value.match(
                                  accountTitle_AccountNumber_Regex,
                                ) ||
                                e.target.value == ""
                              ) {
                                setAccTitle(e.target.value);
                                setAccTitleError("");
                              }
                            }}
                          />
                          {/* {accTitleError ? <p className="error-labels error-message2">{accTitleError}</p> : ''} */}
                        </div>
                      </div>

                      <div className="form-group  ">
                        <label>Account No</label>
                        <div>
                          <input
                            type="text"
                            className={`form-control  w-100 ${
                              accNoError ? "required-border" : ""
                            }`}
                            value={accNo}
                            onChange={(e) => {
                              if (
                                e.target.value.match(
                                  accountTitle_AccountNumber_Regex,
                                ) ||
                                e.target.value == ""
                              ) {
                                setAccNo(e.target.value);
                                setAccNoError("");
                              }
                            }}
                          />
                          {/* {accNoError ? <p className="error-labels error-message">{accNoError}</p> : ''} */}
                        </div>
                      </div>

                      <Row>
                        <Col md="6">
                          <div className="form-group  ">
                            <label>Bank Name</label>
                            <div>
                              <Select
                                className={`${
                                  bankNameError ? "required-border" : ""
                                }`}
                                value={selectedBankName}
                                label={"Select Bank"}
                                onChange={(e) => {
                                  setBankNameError("");
                                  setBankName(e?.value);
                                  getBranchByName(e?.value);
                                }}
                                menuPortalTarget={document.body}
                                menuShouldBlockScroll={true}
                                isClearable={true}
                                isSearchable={true}
                                name="color"
                                options={renderBankNameDropdown()}
                                styles={customStyles}
                              />
                              {/* <select
                                className={`form-control  w-100 ${bankNameError ? "required-border" : ""
                                  }`}
                                value={bankname}
                                onChange={(e) => {
                                  setBankNameError("");
                                  setBankName(e.target.value);
                                  getBranchByName(e.target.value);
                                }}
                              >
                                <option value="" defaultChecked hidden>
                                  {" "}
                                  Select Bank
                                </option>
                                {renderBankNameDropdown()}
                                <option value="Other">Other</option>
                              </select> */}
                              {/* {bankNameError ? <p className="error-labels error-message2">{bankNameError}</p> : ''} */}
                            </div>
                          </div>
                        </Col>
                        <Col md="6">
                          <div className="form-group  ">
                            <label>Branch Name</label>

                            <input
                              type="text"
                              className={`form-control  w-100 ${
                                bankNameError ? "required-border" : ""
                              }`}
                              value={branchName}
                              onChange={(e) => {
                                setBankNameError("");
                                setBranchName(e.target.value);
                              }}
                            />

                            {/* <ReactTooltip	
                      textColor="white"	
                      backgroundColor="black"	
                      multiline={true}	
                      effect="float"	
                    />	
                    <div	
                      className=" "	
                      id="x"	
                      data-tip={`First Select Bank`}	
                    >	
                      {branchLoading ? (	
                         <div className="form-group">	
                          <div className="ml-2 form-control" >Branch Loading	
                           <i className="fa fa-spinner fa-spin fa-1x ml-3" aria-hidden="true"></i> 	
                          </div> 	
                         </div>	
                      ) : (	
                        <select	
                          className={`form-control  w-100 ${	
                            branchNameError ? 'required-border' : ''	
                          }`}	
                          value={branchName}	
                          onChange={(e) => {	
                            setBankNameError('');	
                            setBranchName(e.target.value);	
                          }}	
                        >	
                          <option value="" defaultChecked hidden>	
                            {branchCheckFlag	
                              ? 'No Branch Found'	
                              : 'Select Branch Name'}	
                          </option>	
                          {renderBranchsDropdown()}	
                        </select>	
                      )}	
                     </div>	 */}
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>

                {/*add new cards  */}
                {type === "Individual" && (
                  <Col md="4">
                    <Card>
                      <CardHeader>
                        <CardTitle tag="h4">Guardian Details</CardTitle>
                      </CardHeader>
                      <CardBody>
                        <div className="form-group">
                          <label>Guardian Name </label>
                          <div>
                            <input
                              type="text"
                              className={`form-control  w-100 ${
                                nameError ? "required-border" : ""
                              }`}
                              value={guardian_name}
                              onChange={(e) => {
                                setGuardian_name(e.target.value);
                                // setNameError('');
                              }}
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label>Guardian Relation </label>
                          <div>
                            <input
                              type="text"
                              className={`form-control  w-100 ${
                                nameError ? "required-border" : ""
                              }`}
                              value={guardian_relation}
                              onChange={(e) => {
                                setGuardian_relation(e.target.value);
                                // setNameError('');
                              }}
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label>Guardian CNIC </label>
                          <div>
                            {/* <input		
                        type="number"		
                        className={`form-control  w-100 ${		
                          nameError ? 'required-border' : ''		
                        }`}		
                        value={guardian_cnic}		
                        onChange={(e) => {		
                          setGuardian_cnic(e.target.value);		
                          // setNameError('');		
                        }}		
                      />		 	 */}
                            <InputMask
                              className={`form-control  w-100 ${
                                nameError ? "required-border" : ""
                              }`}
                              mask="99999-9999999-9"
                              value={guardian_cnic}
                              onChange={(e) => {
                                setGuardian_cnic(e.target.value);
                              }}
                            ></InputMask>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                )}
                {type === "Individual" && (
                  <Col md="4">
                    <Card>
                      <CardHeader>
                        <CardTitle tag="h4">Nominee Details</CardTitle>
                      </CardHeader>
                      <CardBody>
                        <div className="form-group">
                          <label>Nominee Name </label>
                          <div>
                            <input
                              type="text"
                              className={`form-control  w-100 ${
                                nameError ? "required-border" : ""
                              }`}
                              value={nominee_name}
                              onChange={(e) => {
                                setNomineeName(e.target.value);
                                setNameError("");
                              }}
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label>Nominee Relation </label>
                          <div>
                            <input
                              type="text"
                              className={`form-control  w-100 ${
                                nameError ? "required-border" : ""
                              }`}
                              value={nominee_relation}
                              onChange={(e) => {
                                setNomineeRelation(e.target.value);
                                // setNameError('');
                              }}
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label>Nominee CNIC </label>
                          <div>
                            {/* <input		
                        type="number"		
                        className={`form-control  w-100 ${		
                          nameError ? 'required-border' : ''		
                        }`}		
                        value={nominee_cnic}		
                        onChange={(e) => {		
                          setNomineeCnic(e.target.value);		
                          // setNameError('');		
                        }}		
                      />		 	 */}

                            <InputMask
                              className={`form-control  w-100 ${
                                nameError ? "required-border" : ""
                              }`}
                              mask="99999-9999999-9"
                              value={nominee_cnic}
                              onChange={(e) => {
                                setNomineeCnic(e.target.value);
                              }}
                            ></InputMask>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                )}
                {unitholderType && unitholderType !== "Employee" && (
                  <>
                    <Col md="4">
                      <Card>
                        <CardHeader>
                          <CardTitle tag="h4">Joint Holder 1</CardTitle>
                        </CardHeader>
                        <CardBody>
                          <div className="form-group">
                            <label> Name </label>
                            <div>
                              <input
                                type="text"
                                className={`form-control  w-100 ${
                                  nameError ? "required-border" : ""
                                }`}
                                value={joint_h_1_name}
                                onChange={(e) => {
                                  setJointHolderOneName(e.target.value);
                                  // setNameError('');
                                }}
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label>Father/Spouse Name </label>
                            <div>
                              <input
                                type="text"
                                className={`form-control  w-100 ${
                                  nameError ? "required-border" : ""
                                }`}
                                value={joint_h_1_father_spouse}
                                onChange={(e) => {
                                  setJointHolderOneFather(e.target.value);
                                  setNameError("");
                                }}
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label> CNIC </label>
                            <div>
                              {/* <input		
                        type="number"		
                        className={`form-control  w-100 ${		
                          nameError ? 'required-border' : ''		
                        }`}		
                        value={joint_h_1_cnic}		
                        onChange={(e) => {		
                          setJointHolderOneCnic(e.target.value);		
                          // setNameError('');		
                        }}		
                      />		 	 */}
                              <InputMask
                                className={`form-control  w-100 ${
                                  nameError ? "required-border" : ""
                                }`}
                                mask="99999-9999999-9"
                                value={joint_h_1_cnic}
                                onChange={(e) => {
                                  setJointHolderOneCnic(e.target.value);
                                }}
                              ></InputMask>
                            </div>
                          </div>

                          <div className="form-group">
                            <label>Tax Status</label>
                            <Select
                              value={selectedIncomeTaxStatus}
                              label={"Select Tax Type"}
                              onChange={(e) => {
                                setJointHolderOneTaxStatus(e?.value);
                              }}
                              menuPortalTarget={document.body}
                              menuShouldBlockScroll={true}
                              isClearable={true}
                              isSearchable={true}
                              name="color"
                              options={incomeTaxStatusArr}
                              styles={customStyles}
                            />
                            {/* <select
                          className="form-control"
                          value={joint_h_1_taxStatus}
                          onChange={(e) => {
                            setJointHolderOneTaxStatus(e.target.value);
                          }}
                        >
                          <option value="" hidden>
                            {" "}
                            Select Tax Type
                          </option>
                          <option value="Filer">Filer</option>
                          <option value="Non-Filer">Non-Filer</option>
                        </select> */}
                          </div>
                        </CardBody>
                      </Card>
                    </Col>

                    <Col md="4">
                      <Card>
                        <CardHeader>
                          <CardTitle tag="h4">Joint Holder 2</CardTitle>
                        </CardHeader>
                        <CardBody>
                          <div className="form-group">
                            <label>Name </label>
                            <div>
                              <input
                                type="text"
                                className={`form-control  w-100 ${
                                  nameError ? "required-border" : ""
                                }`}
                                value={joint_h_2_name}
                                onChange={(e) => {
                                  setJointHolderTwoName(e.target.value);
                                  // setNameError('');
                                }}
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label>Father/Spouse Name </label>
                            <div>
                              <input
                                type="text"
                                className={`form-control  w-100 ${
                                  nameError ? "required-border" : ""
                                }`}
                                value={joint_h_2_father_spouse}
                                onChange={(e) => {
                                  setJointHolderTwoFather(e.target.value);
                                  // setNameError('');
                                }}
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label> CNIC </label>
                            <div>
                              {/* <input		
                        type="number"		
                        className={`form-control  w-100 ${		
                          nameError ? 'required-border' : ''		
                        }`}		
                        value={joint_h_2_cnic}		
                        onChange={(e) => {		
                          setJointHolderTwoCnic(e.target.value);		
                          // setNameError('');		
                        }}		
                      />		 	 */}
                              <InputMask
                                className={`form-control  w-100 ${
                                  nameError ? "required-border" : ""
                                }`}
                                mask="99999-9999999-9"
                                value={joint_h_2_cnic}
                                onChange={(e) => {
                                  setJointHolderTwoCnic(e.target.value);
                                }}
                              ></InputMask>
                            </div>
                          </div>

                          <div className="form-group">
                            <label>Tax Status</label>
                            <Select
                              value={selectedIncomeTax2Status}
                              label={"Select Tax Type"}
                              onChange={(e) => {
                                setJointHolderTwoTaxStatus(e?.value);
                              }}
                              menuPortalTarget={document.body}
                              menuShouldBlockScroll={true}
                              isClearable={true}
                              isSearchable={true}
                              name="color"
                              options={incomeTaxStatusArr}
                              styles={customStyles}
                            />
                            {/* <select
                          className="form-control"
                          value={joint_h_2_taxStatus}
                          onChange={(e) => {
                            setJointHolderTwoTaxStatus(e.target.value);
                          }}
                        >
                          <option value="" hidden>
                            {" "}
                            Select Tax Type
                          </option>
                          <option value="Filer">Filer</option>
                          <option value="Non-Filer">Non-Filer</option>
                        </select> */}
                          </div>
                        </CardBody>
                      </Card>
                    </Col>

                    <Col md="4">
                      <Card>
                        <CardHeader>
                          <CardTitle tag="h4">Joint Holder 3</CardTitle>
                        </CardHeader>
                        <CardBody>
                          <div className="form-group">
                            <label>Name </label>
                            <div>
                              <input
                                type="text"
                                className={`form-control  w-100 ${
                                  nameError ? "required-border" : ""
                                }`}
                                value={joint_h_3_name}
                                onChange={(e) => {
                                  setJointHolderThreeName(e.target.value);
                                  setNameError("");
                                }}
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label>Father/Spouse Name </label>
                            <div>
                              <input
                                type="text"
                                className={`form-control  w-100 ${
                                  nameError ? "required-border" : ""
                                }`}
                                value={joint_h_3_father_spouse}
                                onChange={(e) => {
                                  setJointHolderThreeFather(e.target.value);
                                  // setNameError('');
                                }}
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label> CNIC </label>
                            <div>
                              {/* <input		
                        type="number"		
                        className={`form-control  w-100 ${		
                          nameError ? 'required-border' : ''		
                        }`}		
                        value={joint_h_3_cnic}		
                        onChange={(e) => {		
                          setJointHolderThreeCnic(e.target.value);		
                          // setNameError('');		
                        }}		
                      />		 	 */}

                              <InputMask
                                className={`form-control  w-100 ${
                                  nameError ? "required-border" : ""
                                }`}
                                mask="99999-9999999-9"
                                value={joint_h_3_cnic}
                                onChange={(e) => {
                                  setJointHolderThreeCnic(e.target.value);
                                }}
                              ></InputMask>
                            </div>
                          </div>

                          <div className="form-group">
                            <label>Tax Status</label>
                            <Select
                              value={selectedIncomeTax3Status}
                              label={"Select Tax Type"}
                              onChange={(e) => {
                                setJointHolderThreeTaxStatus(e?.value);
                              }}
                              menuPortalTarget={document.body}
                              menuShouldBlockScroll={true}
                              isClearable={true}
                              isSearchable={true}
                              name="color"
                              options={incomeTaxStatusArr}
                              styles={customStyles}
                            />
                            {/* <select
                          className="form-control"
                          value={joint_h_3_taxStatus}
                          onChange={(e) => {
                            setJointHolderThreeTaxStatus(e.target.value);
                          }}
                        >
                          <option value="" hidden>
                            {" "}
                            Select Tax Type
                          </option>
                          <option value="Filer">Filer</option>
                          <option value="Non-Filer">Non-Filer</option>
                        </select> */}
                          </div>
                        </CardBody>
                      </Card>
                    </Col>

                    <Col md="4">
                      <Card>
                        <CardHeader>
                          <CardTitle tag="h4">CDC</CardTitle>
                        </CardHeader>
                        <CardBody>
                          <div className="form-group">
                            <label>Investment Account Service</label>
                            <div>
                              <input
                                type="text"
                                className={`form-control  w-100 `}
                                value={cdc_IAS}
                                onChange={(e) => {
                                  setCDCIAS(e.target.value);
                                }}
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label> CDC Subaccount </label>
                            <div>
                              <input
                                type="text"
                                className={`form-control  w-100 `}
                                value={cdc_subAccount}
                                onChange={(e) => {
                                  setCDCSubAccount(e.target.value);
                                }}
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label>CDC participant ID</label>
                            <div>
                              <input
                                type="text"
                                className={`form-control  w-100 `}
                                value={cdc_participantID}
                                onChange={(e) => {
                                  setCDCParticipantID(e.target.value);
                                }}
                              />
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>

                    <Col md="4">
                      <Card>
                        <CardHeader>
                          <CardTitle tag="h4">Balance Units</CardTitle>
                        </CardHeader>
                        <CardBody>
                          {totalFunds?.length > 0 && (
                            <div className="input-size-pos w-100 ml-auto mb-3 mx-3">
                              <table className="table ">
                                <thead>
                                  <tr>
                                    <th>Fund Name</th>
                                    <th>Fund Unit</th>
                                  </tr>
                                </thead>
                                <tbody>{renderFundDataInTable()}</tbody>
                              </table>
                            </div>
                          )}
                        </CardBody>
                      </Card>
                    </Col>

                    <Col md="4">
                      <Card>
                        <CardHeader>
                          <CardTitle tag="h4">Sales Details</CardTitle>
                        </CardHeader>
                        <CardBody>
                          <div className="form-group">
                            <FormGroup check>
                              <Label check>
                                <Input
                                  type="checkbox"
                                  checked={
                                    salesInHouse == "true" ? true : false
                                  }
                                  onChange={(e) => {
                                    setSalesInHouse((prev) =>
                                      prev == "false" ? "true" : "false",
                                    );
                                  }}
                                />
                                <span className="form-check-sign" />
                                In house sale
                              </Label>
                            </FormGroup>
                          </div>

                          <div className="form-group">
                            <label>Sales Company</label>

                            <div>
                              <Select
                                value={selectedSalesCompany}
                                label={"Select Sales Company"}
                                onChange={(e) => {
                                  setSalesCompany(e?.value);
                                  setSalesInHouse(
                                    allSalesCompany?.find(
                                      (item) => item?.company_code === e?.value,
                                    )?.in_house == true
                                      ? "true"
                                      : "false",
                                  );
                                  setSalesPerson("");
                                }}
                                menuPortalTarget={document.body}
                                menuShouldBlockScroll={true}
                                isClearable={true}
                                isSearchable={true}
                                name="color"
                                options={renderSalesCompany()}
                                styles={customStyles}
                              />
                              {/* <select
                            className="form-control"
                            value={salesCompany}
                            onChange={(e) => {
                              setSalesCompany(e.target.value);
                              setSalesInHouse(
                                allSalesCompany.find(
                                  (item) => item.company_code === e.target.value
                                ).in_house == true
                                  ? true
                                  : false
                              );
                              setSalesPerson("");
                            }}
                          >
                            <option value="" hidden>
                              {" "}
                              Select Sales Company
                            </option>
                            {allSalesCompany?.map((item, index) => {
                              return (
                                <option
                                  key={item.company_code}
                                  value={item.company_code}
                                >
                                  {item.company_name}
                                </option>
                              );
                            })}
                          </select> */}
                            </div>
                          </div>
                          <div className="form-group">
                            <label>Sales Person</label>
                            <div>
                              <Select
                                value={selectedSalesPerson}
                                label={"Select Sales Person"}
                                onChange={(e) => {
                                  setSalesPerson(e?.value);
                                }}
                                menuPortalTarget={document.body}
                                menuShouldBlockScroll={true}
                                isClearable={true}
                                isSearchable={true}
                                name="color"
                                options={renderSalesPerson()}
                                styles={customStyles}
                              />
                              {/* <select
                            className="form-control"
                            value={salesPerson}
                            onChange={(e) => {
                              setSalesPerson(e.target.value);
                            }}
                          >
                            <option value="" hidden>
                              {" "}
                              Select Sales Person
                            </option>
                            {allSalesCompany
                              .find((item) => item.company_code == salesCompany)
                              ?.persons?.map((item, index) => {
                                return (
                                  <option key={item.email} value={item.id}>
                                    {`${item.name}(${item.email})`}
                                  </option>
                                );
                              })}
                          </select> */}
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </>
                )}

                {amcName && unitholderType === "Participant" ? (
                  <Col md="12">
                    <Card>
                      <CardHeader>
                        <CardTitle tag="h4">Systematic investment</CardTitle>
                      </CardHeader>
                      <CardBody>
                        <div className="form-group">
                          <FormGroup
                            check
                            style={{
                              display: "flex",
                              justifyContent: "end",
                              alignItems: "center",
                            }}
                          >
                            <Label check>
                              <Input
                                type="checkbox"
                                checked={autoInvest === "true"}
                                onChange={(e) => {
                                  setAutoInvest((prev) =>
                                    prev === "false" ? "true" : "false",
                                  );
                                }}
                              />
                              <span className="form-check-sign" />
                              Auto Investment
                            </Label>
                            {/* {subFundsBlocks.length < 3 && <button
                         className="btn-round btn-icon btn btn-primary"
                         onClick={addSubFundsBlock}
                       >
                         {" "}
                         <i className="fa fa-plus"></i>{" "}
                       </button>} */}
                          </FormGroup>
                        </div>
                        <Row>
                          <Col>
                            <div className="form-group  ">
                              <label>Allocation Scheme</label>
                              <div>
                                <Select
                                  value={selectedSystematicVPSType}
                                  label={"Select"}
                                  onChange={(e) => {
                                    if (
                                      e?.value ===
                                      "Customized Allocation Scheme"
                                    ) {
                                      setSubFundsBlocks((prevBlocks: any) =>
                                        prevBlocks.map((block: any) => ({
                                          ...block,
                                          parentProportion: 0,
                                          total_amount: 0,
                                          subFunds: block.subFunds.map(
                                            (sf) => ({
                                              ...sf,
                                              proportion: "0.00",
                                              amount: "0.00",
                                            }),
                                          ),
                                        })),
                                      );
                                      setErrors({});
                                    }
                                    setTypeVPS(e?.value);
                                  }}
                                  menuPortalTarget={document.body}
                                  menuShouldBlockScroll={true}
                                  isClearable={true}
                                  isSearchable={true}
                                  name="color"
                                  options={renderSystematicVPSType()}
                                  styles={customStyles}
                                />
                              </div>
                            </div>
                          </Col>

                          <Col>
                            <div className="form-group  ">
                              <label>Amount</label>
                              <div>
                                <NumberFormat
                                  thousandSeparator={true}
                                  value={amount}
                                  placeholder="Enter Amount to Invest"
                                  className="form-control"
                                  onValueChange={(values: any) => {
                                    const { value } = values;
                                    setAmount(parseFloat(value));
                                  }}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                        {amount > 0 &&
                          subFundsBlocks.map((block, blockIndex) => {
                            return (
                              <div
                                key={block.id}
                                style={{
                                  marginBottom: "15px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "end",
                                    alignItems: "center",
                                    marginBottom: "10px",
                                  }}
                                >
                                  {subFundsBlocks.length > 1 && (
                                    <button
                                      type="button"
                                      onClick={() =>
                                        removeSubFundsBlock(block.id)
                                      }
                                      style={{
                                        background: "none",
                                        border: "none",
                                        fontSize: "18px",
                                        color: "#dc3545",
                                        cursor: "pointer",
                                        padding: "0",
                                      }}
                                    >
                                      −
                                    </button>
                                  )}
                                </div>

                                <Row>
                                  <Col>
                                    <div className="form-group">
                                      <label>Fund</label>
                                      <div>
                                        <Select
                                          disabled={false}
                                          value={block.selectedParentFund}
                                          placeholder={
                                            fundLoading
                                              ? "Loading..."
                                              : "Select Fund"
                                          }
                                          onChange={(selectedFund) =>
                                            updateParentFund(
                                              block.id,
                                              selectedFund,
                                            )
                                          }
                                          menuPortalTarget={document.body}
                                          menuShouldBlockScroll={true}
                                          isClearable={true}
                                          isSearchable={true}
                                          name={`parent-fund-${block.id}`}
                                          options={renderVPSFundsDropdown()}
                                          styles={customStyles}
                                        />
                                      </div>
                                    </div>
                                  </Col>
                                  <Col>
                                    <div className="form-group">
                                      <label>Invest</label>
                                      <div style={{ position: "relative" }}>
                                        <NumberFormat
                                          defaultValue={0.0}
                                          value={block?.parentProportion}
                                          className={`form-control pr-5`}
                                          disabled={block?.subFunds?.length > 0}
                                          decimalScale={2}
                                          allowNegative={false}
                                        />
                                        <span
                                          className="input-group-text"
                                          style={{
                                            position: "absolute",
                                            right: "10px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            background: "transparent",
                                            border: "none",
                                            pointerEvents: "none",
                                          }}
                                        >
                                          %
                                        </span>
                                      </div>
                                    </div>
                                  </Col>

                                  <Col>
                                    <div className="form-group">
                                      <label>Amount</label>
                                      <div style={{ position: "relative" }}>
                                        <NumberFormat
                                          defaultValue={0.0}
                                          thousandSeparator={true}
                                          value={block?.total_amount}
                                          className={`form-control pr-5`}
                                          disabled={block?.subFunds?.length > 0}
                                          decimalScale={2}
                                          allowNegative={false}
                                        />
                                        <span
                                          className="input-group-text"
                                          style={{
                                            position: "absolute",
                                            right: "10px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            background: "transparent",
                                            border: "none",
                                            pointerEvents: "none",
                                          }}
                                        ></span>
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                                {block?.fund ? (
                                  <>
                                    {block?.subFunds?.map(
                                      (ele: any, fundIndex) => {
                                        return (
                                          <Row
                                            className="align-items-end"
                                            key={fundIndex}
                                          >
                                            <Col>
                                              <div className="form-group mt-4">
                                                <div>
                                                  <input
                                                    value={ele?.name}
                                                    readOnly
                                                    className="form-control"
                                                  />
                                                </div>
                                              </div>
                                            </Col>
                                            <Col>
                                              <div className="form-group">
                                                <div
                                                  style={{
                                                    position: "relative",
                                                  }}
                                                >
                                                  <small
                                                    className={`${
                                                      errors[fundIndex]
                                                        ? "text-danger"
                                                        : ""
                                                    }`}
                                                    style={{ color: "#6c757d" }}
                                                  >
                                                    {typeVPS ===
                                                    "Customized Allocation Scheme"
                                                      ? ""
                                                      : renderRange(
                                                          ele?.type_VPS,
                                                        )}
                                                  </small>
                                                  {typeVPS ===
                                                  "Customized Allocation Scheme" ? (
                                                    <>
                                                      <FormGroup check>
                                                        <Label
                                                          style={{
                                                            bottom: "12px",
                                                          }}
                                                          check
                                                        >
                                                          <Input
                                                            type="checkbox"
                                                            // Add the 'checked' state based on the current proportion
                                                            checked={
                                                              parseFloat(
                                                                ele?.proportion,
                                                              ) === 100
                                                            }
                                                            onChange={(e) => {
                                                              // ⭐️ NEW HANDLER CALL
                                                              handleCustomCheckboxChange(
                                                                block.id,
                                                                fundIndex,
                                                                e.target
                                                                  .checked,
                                                              );
                                                            }}
                                                          />
                                                          <span className="form-check-sign" />
                                                        </Label>
                                                      </FormGroup>
                                                      <NumberFormat
                                                        defaultValue={0.0}
                                                        // ... (rest of NumberFormat component remains, but needs to be disabled)
                                                        value={ele?.proportion}
                                                        className={`form-control pr-5 ${
                                                          errors[fundIndex]
                                                            ? "border border-danger text-danger"
                                                            : ""
                                                        }`}
                                                        // ⭐️ DISABLE INPUT IF IT'S CHECKED (proportion is 100)
                                                        // disabled={parseFloat(ele?.proportion) === 100}
                                                        disabled
                                                        // The isAllowed and onValueChange logic are only needed if the input ISN'T disabled
                                                        decimalScale={2}
                                                        allowNegative={false}
                                                      />
                                                    </>
                                                  ) : (
                                                    <NumberFormat
                                                      defaultValue={0.0}
                                                      value={ele?.proportion}
                                                      // 2. UPDATE CLASS NAME CHECK
                                                      className={`form-control pr-5 ${
                                                        errors[fundIndex]
                                                          ? "border border-danger text-danger"
                                                          : ""
                                                      }`}
                                                      isAllowed={(values) =>
                                                        isAllowedInvestProporation(
                                                          values,
                                                          ele,
                                                          fundIndex,
                                                        )
                                                      }
                                                      onValueChange={(
                                                        values,
                                                      ) => {
                                                        const { value } =
                                                          values;
                                                        updateProportion(
                                                          block.id,
                                                          fundIndex,
                                                          value || "",
                                                        );
                                                      }}
                                                      decimalScale={2}
                                                      allowNegative={false}
                                                    />
                                                  )}
                                                  <span
                                                    className={`input-group-text ${
                                                      errors[fundIndex]
                                                        ? "text-danger"
                                                        : ""
                                                    }`}
                                                    style={{
                                                      position: "absolute",
                                                      right: "10px",
                                                      top: "66%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      background: "transparent",
                                                      border: "none",
                                                      pointerEvents: "none",
                                                    }}
                                                  >
                                                    %
                                                  </span>
                                                </div>
                                                {errors[fundIndex] && (
                                                  <small className="text-danger">
                                                    {errors[fundIndex]}
                                                  </small>
                                                )}
                                              </div>
                                            </Col>
                                            <Col>
                                              <div className="form-group mt-4">
                                                <div>
                                                  <NumberFormat
                                                    defaultValue={0.0}
                                                    thousandSeparator={true}
                                                    value={ele?.amount}
                                                    disabled
                                                    className={`form-control pr-5`}
                                                    decimalScale={2}
                                                    allowNegative={false}
                                                  />
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                        );
                                      },
                                    )}
                                  </>
                                ) : null}
                              </div>
                            );
                          })}
                        <Row
                          style={{
                            marginTop: "20px",
                            borderTop: "2px solid #ccc",
                            paddingTop: "10px",
                          }}
                        >
                          <Col></Col>
                          <Col>
                            <div
                              style={{
                                textAlign: "right",
                                fontWeight: "bold",
                                color:
                                  subFundsBlocks[0]?.parentProportion == 100
                                    ? "#28a745"
                                    : "#dc3545",
                                fontSize: "16px",
                              }}
                            >
                              Grand Total Proportion:{" "}
                              {subFundsBlocks[0]?.parentProportion}%
                              {/* {subFundsBlocks[0]?.parentProportion < 100 && (
                             <div style={{ fontSize: '14px', color: '#dc3545', fontWeight: 'normal' }}>
                               ⚠️ **Grand Total** exceeds the 100% limit.
                             </div>
                           )} */}
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                ) : null}

                {unitholderType && unitholderType === "Employee" && (
                  <Col md="12">
                    <Card>
                      <CardHeader>
                        <CardTitle tag="h4">
                          Nominee
                          <div>
                            {employeeNominee?.length > 1 && (
                              <button
                                className="btn-round btn-icon btn btn-primary"
                                onClick={() => {
                                  handleRemoveEmployeeNominee();
                                }}
                              >
                                {" "}
                                <i className="fa fa-minus"></i>{" "}
                              </button>
                            )}
                            <button
                              className="btn-round btn-icon btn btn-primary"
                              onClick={() => {
                                handleAddEmployeeNominee();
                              }}
                            >
                              {" "}
                              <i className="fa fa-plus"></i>{" "}
                            </button>
                          </div>
                        </CardTitle>
                      </CardHeader>
                      <CardBody>
                        {employeeNominee?.map((ele, index) => {
                          return (
                            <Row>
                              <Col>
                                <div className="form-group">
                                  <label>Nominee Name</label>
                                  <div>
                                    <input
                                      type="text"
                                      className={`form-control w-100 `}
                                      value={ele?.nominee_name}
                                      onChange={(e) => {
                                        let temp: any = [...employeeNominee];
                                        temp[index].nominee_name =
                                          e?.target?.value;
                                        setEmployeeNominee(temp);
                                      }}
                                    />
                                  </div>
                                </div>
                              </Col>
                              <Col>
                                <div className="form-group">
                                  <label>Nominee Relation</label>
                                  <div>
                                    <input
                                      type="text"
                                      className={`form-control w-100 `}
                                      value={ele?.nominee_relation}
                                      onChange={(e) => {
                                        let temp: any = [...employeeNominee];
                                        temp[index].nominee_relation =
                                          e?.target?.value;
                                        setEmployeeNominee(temp);
                                      }}
                                    />
                                  </div>
                                </div>
                              </Col>
                              <Col>
                                <div className="form-group">
                                  <label>Nominee CNIC</label>
                                  <div>
                                    <InputMask
                                      className={`form-control w-100`}
                                      mask="99999-9999999-9"
                                      value={ele?.nominee_cnic}
                                      onChange={(e) => {
                                        let temp: any = [...employeeNominee];
                                        temp[index].nominee_cnic =
                                          e?.target?.value;
                                        setEmployeeNominee(temp);
                                      }}
                                    ></InputMask>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          );
                        })}
                      </CardBody>
                    </Card>
                  </Col>
                )}
              </Row>

              <button
                className="btn btn-primary mr-2"
                onClick={addClients}
                disabled={Boolean(Loading)}
              >
                {Loading ? (
                  <>
                    <span
                      className="spinner-border login-txt spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span className="login-txt"> Loading...</span>
                  </>
                ) : (
                  <span>Update</span>
                )}
              </button>
              <button
                className="btn btn-default"
                onClick={() => {
                  history.replace("/admin/unit-holders");
                }}
              >
                Cancel
              </button>
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default EditClients;
